// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"706b5aaa","703":"63b1cd64"}[chunkId] + ".chunk.js";
};